import template from './index.html'
import controller from './controller'

export const vsName = 'meallogDetailEntry'
export const vsNgType = 'directive'

MealLogDetailEntry.$inject = []
export function MealLogDetailEntry() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: template,
    scope: {
      model: '='
    }
  }
}
